export interface style {
  themeName?: string,
  navBackground?: string;
  navFontColor?: string;
  bodyBgColor?: string;
}

export enum ThemesNames{
  theme1 = 'theme1',
  theme2 = 'theme2',
  theme3 = 'theme3',
  theme4 = 'theme4',
  theme5 = 'theme5',
  inverse = 'inverse',
  renforce = 'renforce',
}

export enum PoliceNames{
  default = 'default',
  dyslexie = 'dyslexie',
}

export enum Interlignage{
  default = 'interlignage-default',
  augmenter = 'interlignage-augmenter',
}
